import WOW from 'wow.js';
import feather from 'feather-icons';
import CookieNotice from './components/cookie-notice.js';
import ACFMap from './components/acfmap.js';
import DealerMap from './components/dealerMap.js';
import WorldMap from './components/worldMap.js';
import Counter from './components/counter.js';
import LoginAnimation from './components/loginAnimation.js';
import fslightbox from 'fslightbox';

import GoogleMapsLoader from 'google-maps';

import { polyfill } from 'es6-promise';

polyfill();

// if ( document.getElementById('cookie-accept') ) {
// 	CookieNotice.init();	
// }

// Replace feather icons
feather.replace();

// Init WOW.js
new WOW().init();

// Init login page animation
LoginAnimation.init();

if ( document.querySelectorAll('.wowCount').length !== 0 ) {
  let obj = document.querySelectorAll('.wowCount');
  for (let i = 0; i < obj.length; i++) {
    Counter.init(WOW, obj[i].getAttribute('id'), obj[i].dataset.number);
  }
};

var count = jQuery('.swiper-container').data('count');
var mySwiper = new Swiper ('.swiper-container', {
  loop: count < 2 ? false : true,
	autoplay: {
		delay: 5000,
	},
	speed: 1000,
	// Navigation arrows
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},

})

if ( document.querySelectorAll('.map-container').length !== 0 ) {
    DealerMap.init('', document.querySelectorAll('.has-map')[0]);
};
if ( document.querySelectorAll('.world-map-container').length !== 0 ) {
    WorldMap.init(document.querySelectorAll('.has-world-map')[0]);
};


//   document.querySelector('.is-search-button').addEventListener('click', function() {
//     if (document.querySelector('.search-container').style.display == 'none') {
//       document.querySelector('.search-container').style.display = 'block';
//     } else {
//       document.querySelector('.search-container').style.display = 'none';
//     }
//   });


//   document.querySelector('.hamburger').addEventListener('click', function() {
//     document.getElementsByTagName("BODY")[0].classList.toggle('overflow-hidden');
//     this.classList.toggle("change");
//     document.querySelector('.mobile-menu').classList.toggle('flex');
//   });



  if ( document.querySelectorAll('.tab-header').length !== 0 ) {
    let tabHeader = document.querySelectorAll('.tab-header');
    for(let i = 0; i < tabHeader.length; i++) {
      tabHeader[i].addEventListener('click', function(){
        // console.log(this.children[0].children[1].children[0]);
        let arrow = this.children[0].children[1].children[0];
        let icon = document.querySelectorAll('chevron-icon-down');
        if (this.children[0].children[1].classList.contains('chevron-icon-down')) {
          this.children[0].children[1].classList.toggle('rotate');
        }
        this.nextElementSibling.classList.toggle('active');
      });
    }
  };

//   if ( document.querySelectorAll('.mobile-dropdown-hover-1').length !== 0 ) {
//     let mobileDropdown1 = document.querySelectorAll('.mobile-dropdown-hover-1');
//     for(let i = 0; i < mobileDropdown1.length; i++) {
//       mobileDropdown1[i].addEventListener('click', function(){
//         this.parentElement.classList.toggle('active');
//         this.classList.toggle('rotate-cross');
//         // console.log(this.children[0].children[1].children[0]);
//         let arrow = this.children[0].children[1].children[0];
//         // console.log(this.nextElementSibling.children[0].children[0].classList.add('wow','fadeInLeft'));
//         if (this.children[0].children[1].classList.contains('feather-chevron-up')) {
//           this.children[0].children[1].classList.toggle('rotate');
//         }
//         this.nextElementSibling.classList.toggle('active');
//       });
//     }
//   };
//   if ( document.querySelectorAll('.mobile-dropdown-hover-2').length !== 0 ) {
//     let mobileDropdown2 = document.querySelectorAll('.mobile-dropdown-hover-2');
//     for(let i = 0; i < mobileDropdown2.length; i++) {
//       mobileDropdown2[i].addEventListener('click', function(){
//         this.parentElement.classList.toggle('active');
//         this.classList.toggle('rotate-cross');
//         // console.log(this.children[0].children[1].children[0]);
//         let arrow = this.children[0].children[1].children[0];
//         this.nextElementSibling.children[0].children[0].classList.add('wow','fadeInLeft');
//         if (arrow.classList.contains('feather-chevron-up')) {
//           arrow.classList.toggle('rotate');
//         }
//         this.nextElementSibling.classList.toggle('active');
//       });
//     }
//   };

  // if ( document.querySelectorAll('.has-map').length !== 0 ) {
  //     ACFMap.init('', document.querySelectorAll('.has-map')[0]);
  //   GoogleMapsLoader.KEY = 'AIzaSyA0-sMebfXnmuOVDQvM27TkrSBL2ZyU_B8';
  //   GoogleMapsLoader.load((google) => { mapLoaded(google); });
  //   console.log(document.querySelectorAll('.map')[0]);
  //   function mapLoaded(google) {
  //     // console.log(google);
  //   }
  //   // console.log(document.quer<ySelector('.map'));
  //   ACFMap.init('', document.querySelectorAll('.map'));
  // };




//   let hoverItems = document.querySelectorAll('.dropdown-hover-1');
//   let dropdownBg = document.querySelector('.dropdown-bg');

//   for(let i = 0; i < hoverItems.length; i++) {
//     hoverItems[i].addEventListener('mouseenter', function() {
//       if( !dropdownBg.classList.contains('test') ) {
//         dropdownBg.classList.remove('hidden');
//       }
//     });
//     hoverItems[i].addEventListener('mouseleave', function() {
//       dropdownBg.classList.add('hidden');
//     });
//   }
  

// // let hoveredElement = null;
// // document.addEventListener( "mouseover", function(e){
// //     let originalBG = '#EE7F01';
// //     let lightColor = 'fff';
// //     let gradientSize = 1;
// //     hoveredElement = e.target;
// //     // console.log(e.screenX);
// //     if (hoveredElement.classList.contains('btn')) {
// //         // console.log(hoveredElement);
// //         hoveredElement.addEventListener('mousemove', function(e) {
// //             let x = e.screenX - this.offsetLeft;
// //             let y = e.screenY - this.offsetTop;
// //             let xy = x + " " + y;
// //             let bgWebKit = "-webkit-gradient(radial, " + xy + ", 0, " + xy + ", 80, from(rgba(255,255,25 5,0.095)), to(rgba(255,255,255,0.0))), " + originalBG;
// //             this.style.background = bgWebKit;
// //             // console.log(this);
// //         })
// //         hoveredElement.addEventListener('mouseleave', function(e) {
// //             this.style.background = originalBG;
// //         })
// //     }
// // });

jQuery(document).ready(function () {
  // HeartsBackground.initialize();

	// VideoSource
	videoSource();

	// Block: Slideshow
	const SlideshowSwiper = new Swiper('.block-slideshow_slider', {
		// Optional parameters
		loop: true,
		autoHeight: true,
	  
		// If we need pagination
		pagination: {
		  el: '.swiper-fraction',
		  type: 'fraction',
		},
	  
		// Navigation arrows
		navigation: {
		  nextEl: '.swiper-button-next',
		  prevEl: '.swiper-button-prev',
		},
	});


	// Toggle menu switcher
	jQuery('#wp-admin-bar-toggle_menu_switcher_transient a').click(function(e) {
		e.preventDefault();

		jQuery.ajax({
			url: '/wp-json/menu-switch/v1/toggle/',
			method: 'GET',
			beforeSend: function(xhr) {
				xhr.setRequestHeader('X-WP-Nonce', themeScript.nonce);
			},
			success: function(data) {
				if (data.success) {
					location.reload();
				} else {
					alert('Error toggling menu');
				}
			}
		});
	});


	// Nav har children. Lägg till arrow när det finns children
	jQuery('.menu-item-has-children > a').append('<div class="nav-icon"></div>');

	var config = {
		namespace: '.navigation',
	};

	// Check if touchscreen
	// https://stackoverflow.com/a/52855084
	if (window.matchMedia("(pointer: coarse)").matches) {
		// touchscreen

		// Open menu level 1 on screens with touch.
		jQuery('nav.main-nav ul.site-navigation > li > a').on('touchend' + config.namespace, function (e) {
			// Öppna undermeny om vid första klick. Om det inte finns en undermeny default action
			if (!jQuery(this).parent().hasClass('active') && jQuery(this).parent().hasClass('menu-item-has-children')) {
				jQuery('nav.main-nav ul.site-navigation > li').removeClass('active');
				jQuery(this).parent().addClass('active');
				jQuery(this).children('.nav-icon').toggleClass('open');
				e.preventDefault();
			} else {
				return true;
			}
		});

		// Open level 2.
		jQuery('nav.main-nav ul.site-navigation > li > ul.sub-menu > li > a').on('click', function (e) {
			// Öppna undermeny om vid första klick. Om det inte finns en undermeny default action
			if (!jQuery(this).parent().hasClass('active') && jQuery(this).parent().hasClass('menu-item-has-children')) {
				jQuery('nav.main-nav ul.site-navigation > li ul.sub-menu > li').removeClass('active');
				jQuery(this).parent().addClass('active');
				jQuery(this).children('.nav-icon').toggleClass('open');
				e.preventDefault();
			} else {
				return true;
			}
		});

		// tapping outside of the dropdown closes it
		jQuery('body').on('touchend' + config.namespace, function () {
			jQuery('nav.main-nav ul.site-navigation > li.menu-item-has-children').removeClass('active');
			jQuery('nav.main-nav ul.site-navigation .nav-icon').removeClass('open');
		});

		// Exception to above: clicking anywhere on the megamenu content will NOT close it
		jQuery('nav.main-nav ul.site-navigation').on('touchend' + config.namespace, function (evt) {
			evt.stopImmediatePropagation();
		});
	} else {

		// Öppna nav on screens without touch
		jQuery('nav.main-nav ul.site-navigation > li > a').on('click', function (e) {
			// Öppna undermeny om vid första klick. Om det inte finns en undermeny default action
			if (!jQuery(this).parent().hasClass('active') && jQuery(this).parent().hasClass('menu-item-has-children')) {
				jQuery('nav.main-nav ul.site-navigation > li').removeClass('active');
				jQuery(this).parent().addClass('active');
				jQuery(this).children('.nav-icon').toggleClass('open');
				e.preventDefault();
			} else {
				return true;
			}
		});

		// Open level 2.
		jQuery('nav.main-nav ul.site-navigation > li > ul.sub-menu > li > a').on('click', function (e) {
			// Öppna undermeny om vid första klick. Om det inte finns en undermeny default action
			if (!jQuery(this).parent().hasClass('active') && jQuery(this).parent().hasClass('menu-item-has-children') ) {
				jQuery('nav.main-nav ul.site-navigation > li ul.sub-menu > li').removeClass('active');
				jQuery(this).parent().addClass('active');
				jQuery(this).children('.nav-icon').toggleClass('open');
				e.preventDefault();
			} else {
				return true;
			}
		});

		// Open level 3.
		jQuery('nav.main-nav ul.site-navigation > li > ul.sub-menu > li > ul.sub-menu > li > a').on('click', function (e) {
			// Öppna undermeny om vid första klick. Om det inte finns en undermeny default action
			if (!jQuery(this).parent().hasClass('active') && jQuery(this).parent().hasClass('menu-item-has-children') ) {
				jQuery('nav.main-nav ul.site-navigation > li ul.sub-menu > li > ul.sub-menu > li').removeClass('active');
				jQuery(this).parent().addClass('active');
				jQuery(this).children('.nav-icon').toggleClass('open');
				e.preventDefault();
			} else {
				return true;
			}
		});

		// tapping outside of the nav closes it
		jQuery('body').on('mouseover' + config.namespace, function () {
			jQuery('nav.main-nav ul.site-navigation > li.menu-item-has-children').removeClass('active');
			jQuery('nav.main-nav ul.site-navigation .nav-icon').removeClass('open');
		});

		// Exception to above: clicking anywhere on the megamenu content will NOT close it
		jQuery('nav.main-nav ul.site-navigation').on('mouseover' + config.namespace, function (evt) {
			evt.stopImmediatePropagation();
		});

	}

	// Mobila meny-knappen
	jQuery('.menu-icon').click(function () {
		var $this = jQuery(this);
		var $menuIcon = $this.children('.menu-icon__icon');
		var $mainNav = jQuery('nav.main-nav');
		var $body = jQuery('body');
		var $navigation = jQuery('.navigation');
	
		var isActive = $menuIcon.hasClass('active');
	
		if (!isActive) {
			$menuIcon.addClass('active');
			$mainNav.addClass('active').removeClass('hide');
			$body.addClass('menu-active');
			$navigation.addClass('menu-active');
		} else {
			$menuIcon.removeClass('active');
			$mainNav.removeClass('active').addClass('hide');
			$body.removeClass('menu-active');
			$navigation.removeClass('menu-active');
			// You might want to handle the search form here, whether to remove the class or not.
		}
	});
	

	// Sök-knappen
	jQuery('.search-icon').click(function () {
		var $this = jQuery(this);
		var $parent = $this.parent();
		var $searchForm = jQuery('.site-search-form');
		var $mainNav = jQuery('nav.main-nav');
		
		var isOpen = $parent.hasClass('active');
		
		$parent.toggleClass('active');
		$this.find('.search-icon__open, .search-icon__close').toggleClass('active');
		
		if (!isOpen) {	
			// Show site search form.
			$searchForm.addClass('active');

			// Focus on search field.
			$searchForm.find('input[name="s"]').focus();
			
			// Hide main navigation.
			$mainNav.addClass('hide');
			
		} else {
			// Hide site search form.
			$searchForm.removeClass('active');
			
			// Show main navigation.
			$mainNav.removeClass('hide');
			
		}
	});

	// FacetWP - Toggle filter
	jQuery('.js-filter-toggle').click(function () {
		jQuery('.js-filter-flyout').toggleClass('active');
	});

	// Close filter
	jQuery('.js-filter-close').click(function () {
		jQuery('.js-filter-flyout').removeClass('active');
	});

	// Accordion.
	jQuery('body').on('click', '.accordion__header', function () {
		//do stuff
		accordion(this);
	});

	// Restart the lightbox after FacetWP loads more content.
	document.addEventListener('facetwp-loaded', function() {
		// Reinitialize FS Lightbox after FacetWP loads new posts
		refreshFsLightbox();
	});

});

/**
 * Accordion
 *
 * Gör en kollapsad div till en accordion
 *
 * @param DOM object
 */
function accordion(element) {
	var _this = jQuery(element);
	if (_this.parent().hasClass('accordion--open') === true) {
		_this.parent().removeClass('accordion--open');
	} else {
		_this.parent().addClass('accordion--open');
	}
}

/**
 * videoSource
 */
function videoSource() {
	if (jQuery('.js-video-layout').length) {
		if (window.matchMedia('(min-width: 40em)')) {
			//console.log('true');

			jQuery('.js-video-layout').each(function (index) {
				var largeVideo = jQuery(this).data('large');
				jQuery(this).attr('src', largeVideo);
				jQuery(this)[0].load();
			});

		}
	}
}
